import type { CSSProperties, JSX, ReactNode } from "react";
import { FB_KINDS, statusOf, type FeedbackKind } from "./model";
import { IconBug, IconCircleHelp, IconLightbulb } from "./icons";

/** Значок вида обращения (ошибка / идея / вопрос) в цвете вида. */
export function KindIcon({
  kind,
  size = 15,
}: {
  kind: FeedbackKind;
  size?: number;
}): JSX.Element {
  const Icon =
    kind === "bug" ? IconBug : kind === "idea" ? IconLightbulb : IconCircleHelp;
  return (
    <span
      className="fk-fb-kind"
      style={{ "--fb-tone": (FB_KINDS[kind] ?? FB_KINDS.question).tone } as CSSProperties}
    >
      <Icon size={size} />
    </span>
  );
}

/** Плашка-пилюля. tone — CSS-цвет (токен), подложка считается от него. */
export function Pill({
  tone,
  children,
  dot,
  title,
}: {
  tone: string;
  children: ReactNode;
  dot?: boolean;
  title?: string;
}): JSX.Element {
  return (
    <span
      className="fk-fb-pill"
      style={{ "--fb-tone": tone } as CSSProperties}
      title={title}
    >
      {dot ? <span className="fk-fb-pill-dot" /> : null}
      {children}
    </span>
  );
}

export function StatusPill({
  status,
  label,
}: {
  status: string;
  label?: string;
}): JSX.Element {
  return (
    <Pill tone={statusOf(status).tone} dot>
      {label ?? statusOf(status).label}
    </Pill>
  );
}

/**
 * Нет входа в CRM: «+» ходит в CRM по её cookie, а в SMS-центр пользователь мог прийти по SSO-токену
 * без cookie (или она истекла). Просим войти в CRM (новая вкладка) и даём проверить ещё раз.
 */
export function CrmLoginNeeded({
  crmUrl,
  onRetry,
}: {
  crmUrl: string;
  onRetry?: () => void;
}): JSX.Element {
  return (
    <div className="fk-fb-login" role="alert">
      <b>Войдите в CRM, чтобы отправить обращение</b>
      <span>
        Обращения уходят в CRM БРАСОЛ, а там вы сейчас не вошли. Войдите и вернитесь
        сюда — текст не потеряется.
      </span>
      <div className="fk-fb-login-actions">
        <a
          className="fk-fb-tool fk-fb-tool--primary"
          href={crmUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Войти в CRM
        </a>
        {onRetry ? (
          <button type="button" className="fk-fb-tool" onClick={onRetry}>
            Я вошёл, проверить
          </button>
        ) : null}
      </div>
    </div>
  );
}
